// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WqNd","tabsBox":"styles_tabsBox__vCRqs","createButton":"styles_createButton__3tBln"};